
import { useState } from 'react'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import { FaPencilAlt, FaTrashAlt, FaUserTie } from "react-icons/fa"
import { ReactComponent as GeneratorIcon } from "../../../shared/img/icon/generator.svg"
import EditClient from '../EditClient'
import useFlashMessage from '../../../hooks/useFlashMessage'
import SelectGenerators from '../../Generator/SelectGenerators/SelectGenerators'
import SelectSellers from '../SelectSellers/SelectSellers'
import { formatCPF, formatCNPJ } from '../../../utils/formatters'

import './ListClientRow.css'

function ListClientRow({ dataArray, myPermissionView, myPermissionDelete, myPermissionEdit, handleOnSelect, selectedArray, handleOnSuccess, sellerEnabled, myPermissionGeneratorView, myPermissionGeneratorEdit, myPermissionSellerView, myPermissionSellerEdit, fakeDelete }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [modalEditClient, setModalEditClient] = useState(false)
    const [modalEditGeneratorList, setModalEditGeneratorList] = useState(false)
    const [modalEditSellers, setModalEditSellers] = useState(false)
    const [clientId, setClientId] = useState("")
    const [client, setClient] = useState({})
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [clientName, setClientName] = useState("")

    const saveGeneratorsLinkedToClient = async (generatorList) => {
        let msgType = 'success'
        const data = await api.patch(`client/generator/${client._id}`, { generators: generatorList }, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then(r => r.data).catch(err => { msgType = 'error'; return err.response.data })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') { setModalEditGeneratorList(false); handleOnSuccess() }
    }

    const saveAssociatedUsers = async (sellersList) => {
        let msgType = 'success'
        const data = await api.patch(`client/sellers/${client._id}`, { associatedUsers: sellersList }, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then(r => r.data).catch(err => { msgType = 'error'; return err.response.data })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') { setModalEditSellers(false); handleOnSuccess() }
    }

    const formatSellerNames = (users) => {
        const names = (users || []).map((u) => u.name).filter(Boolean)
        if (names.length === 0) return 'Nenhum vendedor'
        if (names.length <= 2) return names.join(', ')
        return `${names.slice(0, 2).join(', ')} +${names.length - 2}`
    }

    async function deleteClient(id) {
        let msgType = 'success'
        const request = fakeDelete
            ? api.patch(`/client/disable/${id}`, {}, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })
            : api.delete(`/client/delete/${id}`, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })
        const data = await request
            .then(r => { handleOnSuccess(); setModalDeleteItem(false); return r.data })
            .catch(err => { msgType = 'error'; return err.response.data })
        setFlashMessage(data.message, msgType)
    }

    return (
        <div>
            {myPermissionView && dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <div className='client-row-text'>
                            <span className='client-row-name'>{item.name}</span>
                            <div className='client-row-meta'>
                                {item.disabled && (
                                    <span className="pg-item-status-disabled">Desabilitado</span>
                                )}
                                {item.personType && (
                                    <span className={`client-type-badge client-type-${item.personType}`}>
                                        {item.personType === 'juridica' ? 'PJ' : 'PF'}
                                    </span>
                                )}
                                {item.personType === 'juridica' && item.CNPJ && (
                                    <span className='client-row-doc'>{formatCNPJ(item.CNPJ)}</span>
                                )}
                                {item.personType === 'fisica' && item.CPF && (
                                    <span className='client-row-doc'>{formatCPF(item.CPF)}</span>
                                )}
                            </div>
                            {(myPermissionGeneratorView || myPermissionSellerView) && (
                                <div className='client-row-links'>
                                    {myPermissionGeneratorView && (
                                        <span className='client-row-link-item client-row-link-generator'>
                                            <GeneratorIcon className='client-row-link-icon' />
                                            {(item.generators || []).length} {(item.generators || []).length === 1 ? 'gerador' : 'geradores'}
                                        </span>
                                    )}
                                    {myPermissionSellerView && (
                                        <span className='client-row-link-item client-row-link-seller'>
                                            <FaUserTie size={11} />
                                            {formatSellerNames(item.associatedUsers)}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionGeneratorView && (
                            <GeneratorIcon
                                className='shd-icon-row-generator'
                                title='Geradores'
                                onClick={() => { setClient(item); setModalEditGeneratorList(true) }}
                            />
                        )}
                        {sellerEnabled && myPermissionSellerView && (
                            <FaUserTie
                                className='shd-icon-row-sellers'
                                title='Vendedores associados'
                                onClick={() => { setClient(item); setModalEditSellers(true) }}
                            />
                        )}
                        {myPermissionEdit && (
                            <FaPencilAlt
                                className='shd-icon-row-edit'
                                title='Editar'
                                onClick={() => { setClientId(item._id); setModalEditClient(true) }}
                            />
                        )}
                        {myPermissionDelete && (
                            <FaTrashAlt
                                className='shd-icon-row-trash'
                                title='Apagar'
                                onClick={() => { setModalDeleteItem(true); setClientId(item._id); setClientName(item.name) }}
                            />
                        )}
                    </div>
                </div>
            ))}

            <Modal
                modalStatus={modalEditGeneratorList}
                changeStatus={setModalEditGeneratorList}
                w={82}
                content={
                    <SelectGenerators
                        handleOnSave={saveGeneratorsLinkedToClient}
                        sellerEnabled={sellerEnabled}
                        readOnly={!myPermissionGeneratorEdit}
                        data={client}
                        dataArray={client.generators}
                        handleOnSuccess={() => { setModalEditGeneratorList(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditGeneratorList(false)}
                    />
                }
            />

            <Modal
                modalStatus={modalEditSellers}
                changeStatus={setModalEditSellers}
                w={70}
                content={
                    <SelectSellers
                        data={client}
                        dataArray={client.associatedUsers}
                        readOnly={!myPermissionSellerEdit}
                        handleOnSave={saveAssociatedUsers}
                        btCancelAction={() => setModalEditSellers(false)}
                    />
                }
            />

            <Modal
                modalStatus={modalEditClient}
                changeStatus={setModalEditClient}
                w={82}
                content={
                    <EditClient
                        sellerEnabled={sellerEnabled}
                        id={clientId}
                        handleOnSuccess={() => { setModalEditClient(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditClient(false)}
                    />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteClient(clientId)}
                message="Deseja realmente excluir esse cliente?"
                itemName={clientName}
            />
        </div>
    )
}

export default ListClientRow
